const $$splitComponentImporter = () => import('/opt/buildhome/repo/src/routes/pro/dashboard/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/pro/dashboard/')({
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});
type Period = 'day' | 'week' | 'month' | 'year';
// ─── Types for API responses ──────────────────────────────────────────────────

interface AnalyticsData {
  revenue: {
    current: number;
    previous: number;
  };
  patients: {
    current: number;
    previousDelta: number;
  };
  bookings: {
    current: number;
    previous: number;
    completionRate: number;
  };
  newPatients: {
    current: number;
    previous: number;
  };
}
interface RevenueTrendPoint {
  label: string;
  revenue: number;
}
interface BookingCategory {
  name: string;
  count: number;
  fill: string;
}

// ─── Fallback mock data for new businesses with no data ──────────────────────